import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  class: "d-block simple-search-result",
  id: "nav-search-results"
}
const _hoisted_2 = {
  key: 0,
  class: "m-3",
  "data-cy": "article-not-found-warning"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", { class: "m-0" }, null, -1)
const _hoisted_4 = {
  key: 1,
  class: "rightP"
}

import Pager from "@common/components/Pager.vue";
import _ from "lodash";
import { computed, onMounted, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import searchRow from "@common/components/SimpleSearchResultRow.vue";

//#region General

export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleSearchResults',
  props: {
    articleDisplayResults: {},
    selectSearchRow: {},
    searchPhrases: {},
    actPage: {},
    lastPage: { type: Boolean },
    loading: { type: Boolean },
    language: {},
    highlightArticleId: {}
  },
  emits: ["selected", "navigate-next", "navigate-previous"],
  setup(__props: any, { emit: emits }) {

const props = __props;

const $route = useRoute();
const { t: $t } = useI18n();


//#endregion

//#region Ref
const searchResultsDisplay = ref();
//#endregion

//#region Methods
const selected = (args: any) => {
  //Event for parent when selection is changed
  emits("selected", args);
};

const refreshSelectionByUrlId = () => {
  const indexOfCurrentArticle = _.findIndex(props.articleDisplayResults, {
    articleId: $route?.params?.id
  });
  searchResultsDisplay.value.clearSelected();
  if (indexOfCurrentArticle != -1) {
    searchResultsDisplay.value.selectRow(indexOfCurrentArticle);
  }
};
//#endregion

//#region Computed
const fields = computed(() => {
  return [
    {
      key: "index",
      label: "",
      sortable: false,
      tdClass: "d-none "
    },
    {
      key: "articleNo",
      label: "",
      sortable: false,
      tdClass: "d-none"
    },
    {
      key: "displaytext",
      label: "",
      sortable: false,
      tdClass: "p-0 simple-search-result-cell",

      escape: false
    }
  ];
});
//#endregion

//#region Watch
watch(
  () => props.selectSearchRow,
  () => {
    refreshSelectionByUrlId();
  }
);

watch(
  () => props.articleDisplayResults,
  () => {
    searchResultsDisplay.value.clearSelected();
    searchResultsDisplay.value.refresh();
  }
);

//#endregion

//#region LifeCycle
onMounted(() => {
  refreshSelectionByUrlId();
});
//#endregion

return (_ctx: any,_cache: any) => {
  const _component_b_table = _resolveComponent("b-table")!
  const _component_b_card = _resolveComponent("b-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_b_card, {
      class: "shadow-none",
      style: {"min-width":"20rem border-0"}
    }, {
      default: _withCtx(() => [
        (!_ctx.articleDisplayResults?.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_unref($t)("noArticleSearchResults")), 1))
          : _createCommentVNode("", true),
        _createVNode(_component_b_table, {
          borderless: "",
          hover: "",
          items: _ctx.articleDisplayResults,
          onRowClicked: selected,
          fields: fields.value,
          selectable: "",
          "select-mode": "single",
          "thead-class": "d-none",
          "tbody-tr-class": "simple-search-result-tr",
          ref_key: "searchResultsDisplay",
          ref: searchResultsDisplay,
          "data-cy": "search-article-result-tbl"
        }, {
          "cell(displaytext)": _withCtx((data) => [
            _createVNode(searchRow, {
              articleId: data.item.articleId,
              articleNo: data.item.articleNo,
              class: _normalizeClass({
              'highlight-row': data.item.articleId == _ctx.highlightArticleId
            }),
              Name: data.item.Name,
              Description: data.item.Description,
              searchPhrases: _ctx.searchPhrases,
              language: _ctx.language
            }, null, 8, ["articleId", "articleNo", "class", "Name", "Description", "searchPhrases", "language"])
          ]),
          _: 1
        }, 8, ["items", "fields"]),
        _hoisted_3,
        (_ctx.articleDisplayResults?.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(Pager, {
                width: "130px",
                onlySingleSteps: "",
                isOnFirstPage: _ctx.actPage <= 0,
                currentPage: _ctx.actPage + 1,
                isOnLastPage: _ctx.lastPage,
                isLoading: _ctx.loading,
                onNextPage: _cache[0] || (_cache[0] = ($event: any) => (emits('navigate-next'))),
                onPrevPage: _cache[1] || (_cache[1] = ($event: any) => (emits('navigate-previous'))),
                "data-cy": "article-search-result-pager"
              }, null, 8, ["isOnFirstPage", "currentPage", "isOnLastPage", "isLoading"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})